// This file is automatically generated. Do not edit it directly.
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ikciksykpncxrhjbbnfg.supabase.co";
const WIDGET_SUPABASE_URL = "https://cloud.hotel3d.ru";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlrY2lrc3lrcG5jeHJoamJibmZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc2MTU3MTcsImV4cCI6MjA2MzE5MTcxN30._jDyk-LtrRYOKdn6zddJr0LLpsUGKqe9RJdkZQUI4Ak";

const PROJECT_REF = 'ikciksykpncxrhjbbnfg';
const PROJECT_STORAGE_KEY = `sb-${PROJECT_REF}-auth-token`;
const LEGACY_STORAGE_KEY = 'supabase.auth.token';

const isWidgetRoute = () => {
  if (typeof window === 'undefined') return false;

  return window.location.pathname.includes('widget.html')
    || window.location.pathname.startsWith('/booking/')
    || window.location.hash.includes('/booking/');
};

const activeSupabaseUrl = isWidgetRoute() ? WIDGET_SUPABASE_URL : SUPABASE_URL;
let onlineWidgetClient: SupabaseClient<Database> | null = null;

// Миграция legacy-токена в project-scoped key (чтобы не выкидывало после обновления)
try {
  if (typeof window !== 'undefined') {
    const legacy = window.localStorage.getItem(LEGACY_STORAGE_KEY);
    const scoped = window.localStorage.getItem(PROJECT_STORAGE_KEY);
    if (!scoped && legacy) {
      window.localStorage.setItem(PROJECT_STORAGE_KEY, legacy);
    }
  }
} catch {
  // ignore storage errors
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const baseSupabase = createClient<Database>(
  activeSupabaseUrl,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      storage: window.localStorage,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // ВАЖНО: project-scoped ключ исключает коллизии между localhost/preview/другими проектами
      storageKey: PROJECT_STORAGE_KEY,
    }
  }
);

export const setOnlineWidgetSupabaseClient = (client: SupabaseClient<Database> | null) => {
  onlineWidgetClient = client;
};

export const supabase = new Proxy(baseSupabase, {
  get(target, prop, receiver) {
    const activeClient = onlineWidgetClient || target;
    const value = Reflect.get(activeClient, prop, receiver);
    return typeof value === 'function' ? value.bind(activeClient) : value;
  },
}) as SupabaseClient<Database>;